import request from "@/utils/request";
// 登录
export function login(data) {
  return request({
    url: "login",
    method: "post",
    data,
  });
}
export function loginPhone(data) {
  return request({
    url: "login/mobile",
    method: "post",
    data,
  });
}
// 发送验证码
export function verifyCode() {
  return request({
    url: "verify_code",
    method: "get"
  });
}
export function loginVerify(data) {
  return request({
    url: "login/verify",
    method: "post",
    data,
  });
}
// 获取用户信息
export function getuserinfo() {
  return request({
    url: "user/info",
    method: "get"
  });
}
// 获取扫码后的信息
export function getloginCodeAapi(data) {
  return request({
    url: "logConfirm",
    method: "post",
    data,
  });
}
// 获取扫码后的信息
export function getloginlogapi(data) {
  return request({
    url: "logQrcode",
    method: "get",
    params:data
  });
}
// 获取企业的信息
export function getbusinessInfoapi(data) {
  return request({
    url: "card/info",
    method: "get",
    params:data
  });
}
// 获取活动订单
export function ordersApi(data) {
  return request({
    url: "user/order/orderlist",
    method: "get",
    params:data
  });
}
// 在线客服
export function getWechatContactApi(data) {
  return request({
    url: "chatgroup/getWechatContact",
    method: "get",
    params:data
  });
}
// 星推官
export function distributeExamineApi(data) {
  return request({
    url: "distribute/examine",
    method: "get",
    params:data
  });
}
// 查询合伙人
export function searchPartnerApi(data) {
  return request({
    url: "business/city",
    method: "get",
    params:data
  });
}
// 合伙人合作申请列表
export function cityConsultListApi(data) {
  return request({
    url: "business/cityConsultList",
    method: "get",
    params:data
  });
}
// 新人学习群
export function learnGroupInfoApi(data) {
  return request({
    url: "common/learn_group/info",
    method: "post",
   data
  });
}
// 星推官导入
export function distributeImportEcxcelApi(data) {
  return request({
    url: "distribute/importExcel",
    method: "post",
   data
  });
}
// 修改用户的信息
export function userSettingApi(data) {
  return request({
    url: "user/setting",
    method: "post",
    data,
  });
}
// 删除订单
export function orderDeleteApi(data) {
  return request({
    url: "user/order/delete",
    method: "put",
    data,
  });
}
// 取消订单
export function orderCancelApi(data) {
  return request({
    url: "user/order/cancel",
    method: "put",
    data,
  });
}
// 确认订单
export function orderConfirmDeliveryApi(data) {
  return request({
    url: "user/order/confirmDelivery",
    method: "put",
    data,
  });
}
// 修改密码
export function bindPasswordApi(data) {
  return request({
    url: "user/bind/password",
    method: "post",
    data,
  });
}
// 绑定邀请人
export function bindSpreadApi(data) {
  return request({
    url: "user/bind/spread",
    method: "post",
    data,
  });
}
// 绑定手机号
export function bindPhoneApi(data) {
  return request({
    url: "user/bind/phone",
    method: "post",
    data,
  });
}
// 绑定手机号前验证
export function smsconfimrmCodeApi(data) {
  return request({
    url: "sms/confirm/code",
    method: "post",
    data,
  });
}
// 绑商务合作
export function feedbackInsertApi(data) {
  return request({
    url: "user/feedback/insert",
    method: "post",
    data,
  });
}
